import _ from 'lodash';

const indexUniqueKey = _.random(1000, 9999);
let uniqueIndex = 1;

export function createId(name) {
    return `${name}-${indexUniqueKey}-${uniqueIndex++}`;
}
